const HeadOfficeStatus = () => {
  if (sessionStorage.getItem('id_unit_produksi') && sessionStorage.getItem('id_unit_produksi') === '1') {
		return true
	} else {
		return false
	}
}

export default HeadOfficeStatus